module.exports = __WEBPACK_EXTERNAL_MODULE__normy_query_core__;